import React from 'react'

import { A } from '@frame/ui-primitives/a'
import { P } from '@frame/ui-primitives/p'

import { TW_EMAIL } from '@frame/lib/constants'

export function ContactUs({ error = false }: { error?: boolean }) {
  return error ? (
    <P>
      To continue your verification, please copy this error into an email to <EmailLink /> including a brief summary
      describing what you were trying to do. A specialist will be with you shortly!
    </P>
  ) : (
    <P>
      Please reach out to <EmailLink /> if you need help or have any questions.
    </P>
  )
}

function EmailLink() {
  return (
    <A href={`mailto:${TW_EMAIL}`} target="_blank" rel="noreferrer">
      {TW_EMAIL}
    </A>
  )
}
